const InactivePage = () => {
  return (
    <div>
      <h1>Utilizator sau companie cu status inactiv</h1>
    </div>
  );
};

export default InactivePage;
